import { takeLatest } from 'redux-saga';
import { call, put } from 'redux-saga/effects';
import { getJSON } from '../util';

export function* init() {
    const phase = yield call(getJSON, '/api/moon-phase/current');

    yield put({
        type: 'moon-phase:set',
        payload: phase,
    });
}

export function* root() {
    yield takeLatest('moon-phase:init', init);
}



// WEBPACK FOOTER //
// ./app/sagas/moon-phase.js